// extracted by mini-css-extract-plugin
module.exports = {"link":"_28cd8699"};